// eslint-disable-next-line import/prefer-default-export
export const state = {
  ready: false,
  alertSocket: false,
  token: null,
  language: null,
  user: {},
  conversations: [],
  conversationsHistory: [],
  activeClientId: '',
  activeClientHistoryId: null,
  conversationStates: {},
  configuration: {
    configuration: {},
    dataBank: [],
    templates: [],
  },
  appIsVisible: true,
  playNotificationSound: true,
  userMultimedia: {},
  theme: '',
  failedMessages: [],
  currentCampaign: null,
  messageFromHistory: false,
};
